import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../services/api'
import { useTranslation } from 'react-i18next'

const PRODUCTS = [
  { id: 'motion_wifi', labelSk: 'Vigilant Motion — WiFi', labelEn: 'Vigilant Motion — WiFi', price: '49 €' },
  { id: 'motion_gsm', labelSk: 'Vigilant Motion — GSM', labelEn: 'Vigilant Motion — GSM', price: '69 €' },
  { id: 'door_wifi', labelSk: 'Vigilant Door — WiFi', labelEn: 'Vigilant Door — WiFi', price: '44 €' },
  { id: 'door_gsm', labelSk: 'Vigilant Door — GSM', labelEn: 'Vigilant Door — GSM', price: '64 €' },
]

export default function Order() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [form, setForm] = useState({ name: '', email: '', phone: '', street: '', city: '', zip: '', country: '', product: 'motion_wifi', quantity: '1', note: '' })
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }))

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    const product = PRODUCTS.find(p => p.id === form.product)
    const subject = `[Objednávka] ${product?.labelSk} — ${form.name}`
    const message = `Produkt: ${product?.labelSk} (${product?.price})\nPočet kusov: ${form.quantity}\nMeno: ${form.name}\nEmail: ${form.email}\nTelefón: ${form.phone}\nUlica: ${form.street}\nMesto: ${form.city}\nPSČ: ${form.zip}\nKrajina: ${form.country || '—'}\nPoznámka: ${form.note || '—'}`
    try {
      await api.post('/support', { name: form.name, email: form.email, subject, message })
      setSent(true)
    } catch {
      setError(t('order.error'))
    } finally {
      setLoading(false)
    }
  }

  const inputStyle: React.CSSProperties = { padding: '14px 16px', borderRadius: 12, border: '1px solid #e0e0e0', fontSize: 15, outline: 'none', width: '100%', boxSizing: 'border-box' }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: 20 }}>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 0' }}>
          <button style={{ background: 'none', border: 'none', color: '#2D7A3A', fontSize: 17, cursor: 'pointer', padding: 0 }} onClick={() => navigate(-1)}>{t('order.backBtn')}</button>
        </div>

        <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 32, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 56, marginBottom: 16 }}>🛒</div>
              <h2 style={{ fontSize: 22, fontWeight: 600, color: '#1a1a1a', margin: '0 0 8px' }}>{t('order.successTitle')}</h2>
              <p style={{ fontSize: 15, color: '#888', margin: '0 0 32px' }}>{t('order.successSub')} <strong>{form.email}</strong></p>
              <button style={{ padding: '12px 32px', borderRadius: 12, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }} onClick={() => navigate('/')}>
                {t('order.back')}
              </button>
            </div>
          ) : (
            <>
              <h1 style={{ fontSize: 22, fontWeight: 600, color: '#1a1a1a', margin: '0 0 6px' }}>{t('order.title')}</h1>
              <p style={{ fontSize: 14, color: '#888', margin: '0 0 28px' }}>{t('order.subtitle')}</p>

              {error && <div style={{ backgroundColor: '#fff0f0', color: '#e74c3c', padding: '12px 16px', borderRadius: 10, fontSize: 14, marginBottom: 16 }}>{error}</div>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <select style={{ ...inputStyle, backgroundColor: '#fff' }} value={form.product} onChange={set('product')}>
                  {PRODUCTS.map(p => (
                    <option key={p.id} value={p.id}>{p.labelSk} — {p.price}</option>
                  ))}
                </select>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <label style={{ fontSize: 14, color: '#555', whiteSpace: 'nowrap' }}>{t('order.quantity')}:</label>
                  <input style={{ ...inputStyle, width: 80, textAlign: 'center' }} type="number" min="1" max="10" value={form.quantity} onChange={set('quantity')} required />
                </div>
                <input style={inputStyle} type="text" placeholder={t('order.name')} value={form.name} onChange={set('name')} required />
                <input style={inputStyle} type="email" placeholder={t('order.email')} value={form.email} onChange={set('email')} required />
                <input style={inputStyle} type="tel" placeholder={t('order.phone')} value={form.phone} onChange={set('phone')} required />
                <input style={inputStyle} type="text" placeholder={t('order.street')} value={form.street} onChange={set('street')} required />
                <div style={{ display: 'flex', gap: 10 }}>
                  <input style={{ ...inputStyle, flex: 2 }} type="text" placeholder={t('order.city')} value={form.city} onChange={set('city')} required />
                  <input style={{ ...inputStyle, flex: 1 }} type="text" placeholder={t('order.zip')} value={form.zip} onChange={set('zip')} required />
                </div>
                <input style={inputStyle} type="text" placeholder={t('order.country')} value={form.country} onChange={set('country')} />
                <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 80, fontFamily: 'inherit' } as React.CSSProperties} placeholder={t('order.notePlaceholder')} value={form.note} onChange={set('note')} />
                <button style={{ padding: 14, borderRadius: 12, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer', marginTop: 4 }} type="submit" disabled={loading}>
                  {loading ? t('order.loading') : t('order.submit')}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
